import React from "react";
import T from "prop-types";
import { linkTo } from "MODULES/shared/decorators";
import classNames from "classnames";

export function LinkedTableRow({
  cancelled,
  transition,
  children,
  className = "",
  disabled
}) {
  const classes = classNames(className, {
    "text-muted": cancelled,
    clickable: !disabled
  });

  return (
    <tr className={classes} onClick={disabled ? undefined : transition}>
      {children}
    </tr>
  );
}

LinkedTableRow.propTypes = {
  cancelled: T.bool,
  transition: T.func.isRequired,
  children: T.oneOfType([T.node, T.arrayOf(T.node)]),
  disabled: T.bool,
  className: T.string
};

export default linkTo(({ to }) => to)(LinkedTableRow);



// WEBPACK FOOTER //
// ./app/modules/shared/components/LinkedTableRow/LinkedTableRow.jsx